import ApiService from "@/plugins/ApiService";
import { SET_STATS, SET_LOADING, SET_LISTENERS, SET_LISTENER_REPORT } from "@/store/mutation-types";
import { FETCH_STATS, FETCH_LISTENERS, FETCH_LISTENER_REPORT } from "@/store/action-types";
import _ from 'lodash'

const state = {
    statistics: [],
    listeners: [],
    listener_reports: [],
    top_stats: [],
    chart_reports: [],
}


const mutations = {

    [SET_STATS](state, data) {
        state.statistics = data

    },

    //the endpoint is called repeatedly station
    //when metadata is being fetched

    [SET_LISTENERS](state, data) {

        const transformedData = _.map(data.listeners, (item) => {
            return _.merge(item, item.location);
        })

        //console.log(transformedData);

        //So that it wont be making unnecessary call  to
        //google  map  api
        if (_.isEqual(state.listeners, transformedData)) return
        state.listeners = transformedData

    },

    [SET_LISTENER_REPORT](state, data) {

        state.top_stats = data.top_stats
        state.chart_reports = data.reports

        const transformedData = _.map(data.listeners, (item) => {
            return _.merge(item, item.location);
        })

        // console.log(data);

        // var merged = _.merge(_.keyBy(data.listeners_extra, 'id'), _.keyBy(transformedData, 'id'));
        // var values = _.values(merged);

        state.listener_reports = transformedData

    },


}

const getters = {}


const actions = {

    [FETCH_STATS]: async({ rootState, commit }) => {
        try {
            commit(SET_LOADING, true)
            let response = await ApiService.get(`admin/listeners/${rootState.stations.stationId}`)

            console.log(rootState.stations.stationId);

            commit(SET_STATS, response.data)
            commit(SET_LOADING, false)
        } catch (error) {
            commit(SET_LOADING, false)
            throw error

        }

    },

    [FETCH_LISTENERS]({ commit, rootState }, payload) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {

            // if (state.listeners) {
            //     resolve(state.listeners)
            //     console.log(state.listeners);
            //     return
            // }


            console.log('ccalling');
            ApiService.query(`admin/listeners/${rootState.stations.stationId}`, { params: payload })
                .then(response => {
                    commit(SET_LOADING, false)
                    commit(SET_LISTENERS, response.data.listeners)
                    resolve(response.data.listeners)
                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },


    [FETCH_LISTENER_REPORT]({ commit, rootState }, payload) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {

            ApiService.query(`admin/listeners/${rootState.stations.stationId}`, { params: payload })
                .then(response => {
                    commit(SET_LOADING, false)
                    commit(SET_LISTENER_REPORT, response.data)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },

}

export default {
    state,
    mutations,
    actions
}